import { render } from "./CadastrarColunista.vue?vue&type=template&id=4070134a&scoped=true"
import script from "./CadastrarColunista.vue?vue&type=script&lang=js"
export * from "./CadastrarColunista.vue?vue&type=script&lang=js"

import "./CadastrarColunista.vue?vue&type=style&index=0&id=4070134a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4070134a"]])

export default __exports__